import queryString from 'query-string'
import { usingGet } from '@ocean/api'
import { UNCATEGORISED_CATEGORY_ID } from 'modules/virtualClassrooms/common/helpers'
import {
  EventLibraryFilterItems,
  MyEventsFilterItems,
} from 'modules/virtualClassrooms/student/Events/types'

export const getEventLibraryData = (filters: EventLibraryFilterItems, categoryId?: Guid) => {
  const { filter, searchText } = filters
  const isEventsUncategorised = categoryId === UNCATEGORISED_CATEGORY_ID
  const categoryIdValue = isEventsUncategorised ? undefined : categoryId
  const queryParams = queryString.stringify(
    { categoryId: categoryIdValue, search: searchText.value, eventsLibraryFilter: filter.value },
    {
      skipNull: true,
    }
  )
  const path = `virtualevents/library${isEventsUncategorised ? '/uncategorised' : ''}`

  return usingGet(`${path}?${queryParams}`, { useProxy: true })
}

export const getMyEventsData = (filters: MyEventsFilterItems) => {
  const { periodFilter, searchText } = filters
  const queryParams = queryString.stringify(
    { search: searchText.value, periodFilter: periodFilter.value },
    {
      skipNull: true,
    }
  )

  return usingGet(`virtualevents/myevents?${queryParams}`, { useProxy: true })
}
